import React from 'react';
import { Link as RouterLink } from 'react-router-dom';

import './BigInfo.scss';
import '@components/Link/Link.scss';

const BigInfo = () => (
  <div className="big-info">
    <div className="big-info__link-container">
      <RouterLink
        to="/contact"
        className="link big-info__link"
      >
        Contact us
      </RouterLink>
    </div>
    <div className="big-info__card">
      <div className="big-info__card-title">
        Why Process General?
      </div>
      <div className="big-info__card-highlight">
        Because excellence is the only option
      </div>
      <div className="big-info__card-text">
        Your firm&apos;s needs for legal administration services for bankruptcy and
        class action settlements may be unique, but what remains consistent is
        the necessity for cost-effective, user-friendly systems designed with
        the latest technology and managed by a team superior in their industry.
        At Process General,
        &nbsp;
        <span className="big-info__bold">
          our founders have earned an established reputation for delivering quality,
          cutting-edge service and achieving exceptional outcomes for clients
        </span>
        .
      </div>
    </div>
  </div>
);

export default BigInfo;



// WEBPACK FOOTER //
// ./src/routes/Landing/components/BigInfo/BigInfo.js